import { Section } from '@/components/layout/Section';
import { Button } from '@/components/ui/Button';
import { projects } from '@/content/portfolio';

export function FeaturedWork() {
  const project = projects.find((item) => item.slug === 'consistly')!;
  return (
    <Section id="featured-work" className="border-b border-hairline">
      <div className="grid items-center gap-10 lg:grid-cols-[0.85fr_1.15fr] lg:gap-16">
        <div>
          <p className="text-sm font-medium text-brand">Selected team work / Consistly.ai</p>
          <h2 className="mt-5 text-display-md">From a writing sample to a publishing workflow.</h2>
          <p className="mt-6 max-w-[52ch] text-base leading-relaxed text-ink/75">A commercial platform for planning, drafting and publishing LinkedIn content. Our team's contribution was the AI and automation layer connecting each stage.</p>
          <dl className="mt-8 space-y-5 border-t border-hairline pt-6">
            <div><dt className="font-semibold">The challenge</dt><dd className="mt-2 text-sm leading-relaxed text-ink/70">Keep content relevant to each user's audience and writing style across planning, drafting and publishing.</dd></div>
            <div><dt className="font-semibold">The work</dt><dd className="mt-2 text-sm leading-relaxed text-ink/70">Connect onboarding profiles, weekly idea generation, voice-matched drafts and scheduled publishing.</dd></div>
          </dl>
          <Button href="/portfolio/consistly" variant="brand" className="mt-8">Explore the Consistly.ai project</Button>
        </div>
        <figure className="overflow-hidden rounded-2xl border border-hairline bg-surface-muted">
          <a href="/portfolio/consistly" className="block" aria-label="Explore the Consistly.ai project">
            <img src={project.images[0].src} alt={project.images[0].alt} width={1448} height={1086} loading="lazy" decoding="async" className="h-auto w-full" />
          </a>
          <figcaption className="border-t border-hairline px-6 py-5 text-sm leading-relaxed text-ink/70">Team contribution: AI engineering, workflow automation and LinkedIn integration.</figcaption>
        </figure>
      </div>
      <ol className="mt-12 grid gap-4 border-t border-hairline pt-8 sm:grid-cols-2 lg:grid-cols-4" aria-label="Content workflow">
        {['Capture expertise and voice', 'Generate weekly content ideas', 'Draft from the user profile', 'Schedule and publish'].map((step, index) => (
          <li key={step} className="flex gap-3 text-sm leading-relaxed"><span className="font-semibold text-brand" aria-hidden="true">{index + 1}.</span>{step}</li>
        ))}
      </ol>
    </Section>
  );
}
